export function getDataAndAriaProps(props: Record<string, unknown>) {
  const result: Record<string, unknown> = {};

  for (const [key, value] of Object.entries(props)) {
    if (key.startsWith('data-') || key.startsWith('aria-')) {
      result[key] = value;
    }
  }

  return result;
}
